export enum TConsulta {
  Cpresencial = 'Presencial (Centro de salud)',
  CTelemedicina = 'Telemedicina',
  Cdomiciliaria = 'Visita Domiciliaria',
}

export enum TipoAtencion {
  PRESENCIAL = 'Presencial',
  DOMICILIARIA = 'Domiciliaria',
  TELEMEDICINA = 'Telemedicina'
}

export enum EstadoTratamiento {
  INICIAL, // btn guardar activado
  GUARDADO, // btn guardar oculto, btn editar visible
  EN_EDICION, // btn editar oculto, btn guardar deshabilitado hasta que se haga un cambio
}

export enum EstadoFichaClinica {
  REALIZADA = 'REALIZADA',
  ANULADA = 'ANULADA',
  SUSPENDIDA = 'SUSPENDIDA',
  AGENDADA = 'AGENDADA',
  PROCESO = 'PROCESO',
}

export enum TipoReporteResumenClinico {
  RecetaMedica = 'receta-medica',
  InformeMedico = 'informe-medico',
  Terapias = 'terapias',
  Examenes = 'examenes',
}

export enum SessionKeys {
  PROFILE = 'perfil',
  USER = 'info',
}

export enum StorageType {
  LOCAL = 'local',
  SESSION = 'session',
}

export enum StorageKeys {
  CURRENT_MEDICAL_CENTER = 'currentMedicalCenter',
  CURRENT_DOCTOR = 'currentDoctor',
}

export enum ValidRoles {
  ASSISTANT = 'ASISTENTE_RECEPCION',
  MEDICAL_ASSISTANT = 'ASISTENTE',
  MEDIC = 'MEDICO'
}

export enum AppPermissions {
  EDIT_ANAMNESIS_STORY = 'EDIT_ANAMNESIS_STORY',
  SEE_DIAGNOSIS = 'SEE_DIAGNOSIS',
  CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT',
  EDIT_IDENTIFICATION = 'EDIT_IDENTIFICATION',
  SEE_APPOINTMENT = 'SEE_APPOINTMENT',
  EDIT_ANAMNESIS_VITALS = 'EDIT_ANAMNESIS_VITALS',
  SEE_CALENDAR_EVENT = 'SEE_CALENDAR_EVENT',
  MAKE_UNBLOCK_SCHEDULE = 'MAKE_UNBLOCK_SCHEDULE',
  EDIT_ANAMNESIS_HISTORYS = 'EDIT_ANAMNESIS_HISTORYS',
  EDIT_ANAMNESIS_LIFESTYLE = 'EDIT_ANAMNESIS_LIFESTYLE',
  SEE_EXAMS = 'SEE_EXAMS',
  SEE_TREATMENT = 'SEE_TREATMENT',
  SEE_ANAMNESIS = 'SEE_ANAMNESIS',
  EDIT_EXAMS = 'EDIT_EXAMS',
  MAKE_APPOINTMENT = 'MAKE_APPOINTMENT',
  EDIT_ANAMNESIS_DISEASES = 'EDIT_ANAMNESIS_DISEASES',
  EDIT_ANAMNESIS = 'EDIT_ANAMNESIS',
  EDIT_APPOINTMENT = 'EDIT_APPOINTMENT',
  MAKE_BLOCK_SCHEDULE = 'MAKE_BLOCK_SCHEDULE',
  SEE_IDENTIFICATION = 'SEE_IDENTIFICATION',
  EDIT_DIAGNOSIS = 'EDIT_DIAGNOSIS',
  EDIT_TREATMENT = 'EDIT_TREATMENT'
}

export enum KNOW_ERROR_MESSAGES {
  NO_DATA_FOUND = 'No se encontraron datos',
  NO_DATA_FOUND_BY_ID = 'No se encontraron datos por el id',
  SCHEDULE_ALREADY_BLOCKED = 'Ya existe un bloqueo en el rango de fechas indicado'
}

export enum CategoriaArchivoPaciente {
  HISTORIA_CLINICA = 'HISTORIA_CLINICA',
  OTRO = 'OTRO'
}
